import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { integrationsService } from '@/services/integrationsService';

export const integrationsKeys = {
  all: ['integrations'] as const,
  list: () => [...integrationsKeys.all, 'list'] as const,
};

export function useIntegrations() {
  return useQuery({
    queryKey: integrationsKeys.list(),
    queryFn: () => integrationsService.list(),
    staleTime: 30_000,
    select: (envelope) => envelope.data,
  });
}

export function useStartGoogleConnect() {
  return useMutation({
    mutationFn: () => integrationsService.startGoogleConnect(),
    onSuccess: (envelope) => {
      window.location.assign(envelope.data.authorize_url);
    },
    onError: (err: any) => {
      const message =
        err?.response?.data?.message || 'Could not start Google connect. Please try again.';
      toast.error(message);
    },
  });
}

export function useDisconnectIntegration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (connectionId: string) => integrationsService.disconnect(connectionId),
    onSuccess: () => {
      toast.success('Disconnected');
      queryClient.invalidateQueries({ queryKey: integrationsKeys.list() });
    },
    onError: (err: any) => {
      const message =
        err?.response?.data?.message || 'Could not disconnect. Please try again.';
      toast.error(message);
    },
  });
}
